export const CATEGORIE_UNITAIRE = 'Unitaire';
export const CATEGORIE_REGROUPEMENT = 'Regroupement';
export const CATEGORIE_LOCATION = 'Location';
export const CATEGORIE_DIVERS = 'Divers';

export const PREFIXE_REFERENCE_FACE = 'LC ';
